import { useMemo } from 'react'

import { useAuth } from 'src/auth'

import { State } from '../../types/graphql'

/**
 * Lightweight frontend type representing an organization membership
 * returned by getCurrentUser on the backend (api/src/lib/auth.ts).
 *
 * We define a frontend-specific type rather than importing the Prisma-based
 * CurrentUser type to avoid cross-side Prisma dependency issues.
 */
type OrganizationMembershipOrg = {
  id: number
  displayName: string | null
  city: string
  state: State
}

export type OrganizationMembership = {
  id: number
  organizationId: number
  organization: OrganizationMembershipOrg
}

/**
 * Extracts the user's organization memberships from the auth context
 * and returns them sorted alphabetically by display name (or city/state fallback).
 */
export const useMyOrganizationMemberships = (): OrganizationMembership[] => {
  const { currentUser } = useAuth()

  return useMemo(() => {
    const memberships = currentUser?.userOrganizationMemberships ?? []
    return memberships as OrganizationMembership[]
  }, [currentUser])
}
